export const BASE_URL = 'https://api.art-bazar.am';